<div *ngIf="socio$ | async" class="section">
  <ng-container *ngIf="socio.nome1">
    <p *ngIf="socio.temporary" class="notification  is-primary" i18n="@@newUserWarning">
      Il socio verrà attivato e riceverà il numero tessera contestualmente al pagamento della prima iscrizione. <br />
      Viceversa l'account verrà eliminato entro 30 giorni
    </p>
    <div class="tile is-ancestor">
      <div class="tile is-6 is-parent">
        <div class="tile is-child box">
          <div class="columns is-mobile border-bottom">
            <span  class="column">
              <span class="title is-5 has-text-primary is-uppercase" i18n="@@personalData">Anagrafica</span>
            </span>
            <a class="column is-narrow has-text-primary" (click)="enableDisableEditIndirizzo()" aria-label="more options">
              <span class="icon">
                <i class="fas" [ngClass]="{'fa-undo' : editIndirizzo, 'fa-edit': !editIndirizzo }"></i>
              </span>
            </a>
            <a class="column is-narrow has-text-primary" (click)="setIndirizzo()" *ngIf="editIndirizzo">
              <span class="icon">
                <i class="fas fa-save"></i>
              </span>
            </a>
          </div>
          <form autocomplete="off" #formindirizzo="ngForm">
            <div class="fix-horizontal-form">
              <div class="field is-horizontal">
                <div [ngClass]="{'has-text-danger' : editIndirizzo && !dateModel}" class="field-label is-normal">
                  <label class="label" i18n="@@birthDate">Data nascita</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <ng-container class="control" *ngIf="!editIndirizzo; else fieldDateNascita">
                      <div class="control">
                        <input class="input is-static" readonly type="text" name="fakedatanascitaField"
                          [value]="dateFake">
                      </div>
                    </ng-container>
                    <ng-template #fieldDateNascita>
                      <div class="control is-expanded">
                        <p-calendar [(ngModel)]="dateModel"
                          [inputStyleClass]="(editIndirizzo && !dateModel) ? 'input is-danger' : 'input'"
                          [yearRange]="yearRange" firstDayOfWeek="1" #dateField="ngModel" [required]="true"
                          name="dateField" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true">
                        </p-calendar>
                      </div>
                    </ng-template>
                    <p class="help is-danger" *ngIf="editIndirizzo && !dateModel" i18n="@@dataRequired">
                      Dato richiesto
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@birthPlace" [ngClass]="{'has-text-danger' : editIndirizzo && !socio.luogoNascita}"
                    class="label">Luogo nascita</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.luogoNascita" name="luogoNascitaField"
                        [class.is-static]="!editIndirizzo" [readonly]="!editIndirizzo" maxlength="50" type="text" required
                        [ngClass]="{'is-danger' : editIndirizzo && !socio.luogoNascita}">
                    </div>
                    <p class="help is-danger" *ngIf="editIndirizzo && !socio.luogoNascita" i18n="@@dataRequired">
                      Dato richiesto
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@sex" class="label"
                    [ngClass]="{'has-text-danger' : editIndirizzo && !socio.sesso}">Sesso</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control" *ngIf="!editIndirizzo; else checkBoxSesso">
                      <ng-container [ngSwitch]="socio.sesso">
                        <ng-container *ngSwitchCase="'M'"><input class="input is-static" readonly type="text"
                            name="fieldSexM" value="Maschio" i18n-value="male"></ng-container>
                        <ng-container *ngSwitchCase="'F'"><input class="input is-static" readonly type="text"
                            name="fieldSexF" value="Femmina" i18n-value="female"></ng-container>
                      </ng-container>
                    </div>
                    <ng-template #checkBoxSesso>
                      <input class="is-checkradio" id="mField" type="radio" name="mField" value="M"
                        [(ngModel)]="socio.sesso">
                      <label for="mField" i18n="@@maleLabel">M</label>
                      <input class="is-checkradio" id="fField" type="radio" name="fField" value="F"
                        [(ngModel)]="socio.sesso">
                      <label for="fField" i18n="@@femaleLabel">F</label>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@address" [ngClass]="{'has-text-danger' : editIndirizzo && !socio.indirizzo}"
                    class="label">Indirizzo</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.indirizzo" [class.is-static]="!editIndirizzo"
                        [readonly]="!editIndirizzo" name="indirizzoField" maxlength="255" type="text" required
                        [ngClass]="{'is-danger' : editIndirizzo && !socio.indirizzo}">
                    </div>
                    <p class="help is-danger" *ngIf="editIndirizzo && !socio.indirizzo" i18n="@@dataRequired">
                      Dato richiesto
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@city" [ngClass]="{'has-text-danger' : editIndirizzo && !socio.citta}"
                    class="label">Città</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.citta" name="cittaField" maxlength="100"
                        [class.is-static]="!editIndirizzo" [readonly]="!editIndirizzo" type="text" required
                        [ngClass]="{'is-danger' : editIndirizzo && !socio.citta}">
                    </div>
                    <p class="help is-danger" *ngIf="editIndirizzo && !socio.citta" i18n="@@dataRequired">
                      Dato richiesto
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@zone" [ngClass]="{'has-text-danger' : editIndirizzo && !socio.provincia}"
                    class="label">Provincia</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.provincia" [class.is-static]="!editIndirizzo"
                        name="provinciaField" [readonly]="!editIndirizzo" type="text" maxlength="2" required
                        [ngClass]="{'is-danger' : editIndirizzo && !socio.provincia}">
                    </div>
                    <p class="help is-danger" *ngIf="editIndirizzo && !socio.provincia" i18n="@@dataRequired">
                      Dato richiesto
                    </p>
                  </div>
                  <div class="field">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.cap" [class.is-static]="!editIndirizzo" name="capField"
                        [readonly]="!editIndirizzo" type="text" i18n-placeholder="@@zipCode" placeholder="CAP"
                        maxlength="10" required [ngClass]="{'is-danger' : editIndirizzo && !socio.cap}">
                    </div>
                    <p class="help is-danger" *ngIf="editIndirizzo && !socio.cap" i18n="@@dataRequired">
                      Dato richiesto
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@country" [ngClass]="{'has-text-danger' : editIndirizzo && !socio.codStato}"
                    class="label">Nazione</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="select" [ngClass]="{'is-danger' : editIndirizzo && !socio.codStato}"
                        [style.display]="editIndirizzo ? 'block' : 'none' ">
                        <select name="nazioneField" style="width:100%" [(ngModel)]="socio.codStato" required
                          #statoField="ngModel" id="statoFieldId">
                          <option *ngFor="let nazione of nazioni" [ngValue]="nazione.twoLetterIsoCode">
                            {{nazione.twoLetterIsoCode}} - {{nazione.name}}
                          </option>
                        </select>
                      </div>
                      <input *ngIf="!editIndirizzo" name="fakeStatoField" class="input is-static"
                        [(ngModel)]="socio.codStato" readonly type="text">
                    </div>
                    <p class="help is-danger" *ngIf="editIndirizzo && !socio.codStato" i18n="@@dataRequired">
                      Dato richiesto
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@taxCode" [ngClass]="{'has-text-danger' : (socio.codStato == 'IT' && !socio.codFiscale)}"
                    class="label">Codice Fiscale</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.codFiscale" name="codFiscField" [readonly]="!editIndirizzo"
                        type="text" maxlength="20" #codFiscField="ngModel"
                        [required]="(socio.codStato == 'IT') ? '' : null"
                        [ngClass]="{'is-static': !editIndirizzo, 'is-danger' : editIndirizzo && socio.codStato == 'IT' && !socio.codFiscale}">
                    </div>
                    <p class="help is-danger" *ngIf="socio.codStato == 'IT' && !socio.codFiscale" i18n="@@dataRequired">
                      Dato richiesto
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="tile is-6 is-vertical is-parent">
        <div class="tile is-child box">
          <div class="columns is-mobile border-bottom">
            <span i18n="@@contacts" class="column">
              <span class="title is-5 has-text-primary is-uppercase">Contatti</span>
            </span>
            <a class="column is-narrow" (click)="editContatti = !editContatti">
              <span class="icon">
                <i class="fas" [ngClass]="{'fa-undo' : editContatti, 'fa-edit': !editContatti}"></i>
              </span>
            </a>
            <a *ngIf="editContatti" class="column is-narrow has-text-primary" (click)="setContatti()">
              <span class="icon">
                <i class="fas fa-save"></i>
              </span>
            </a>
          </div>
          <form autocomplete="off" #formcontatti="ngForm">
            <div class="fix-horizontal-form">
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label" [ngClass]="{'has-text-danger' : editContatti && emailField.invalid}">Email</label>
                </div>
                <div class="field-body">
                  <div class="field ">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.email" maxlength="50" email #emailField="ngModel" required
                        name="email" [class.is-static]="!editContatti" [readonly]="!editContatti" type="text"
                        [ngClass]="{'is-danger' : editContatti && emailField.invalid}">
                    </div>
                    <p class="help is-danger" *ngIf="emailField.invalid && editContatti" i18n="@@mailNotValid">
                      Mail non valida
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Newsletter</label>
                </div>
                <div class="field-body">
                  <div class="field ">
                    <div class="control">
                      <input type="checkbox" class="is-checkradio" id="newsletterCheckbox" [(ngModel)]="socio.newsletter"
                        [disabled]="!editContatti || !socio.email" name="newsLetterField">
                      <label for="newsletterCheckbox" style="margin: 0">&nbsp;</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@telephoneNumber" class="label">Telefono</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.telefono" name="telefono" maxlength="255"
                        [class.is-static]="!editContatti" [readonly]="!editContatti" type="text">
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label i18n="@@mobilePhoneNumber" class="label">Cellulare</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" [(ngModel)]="socio.cellulare" name="cellulare" maxlength="20"
                        [class.is-static]="!editContatti" [readonly]="!editContatti" type="text">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="tile is-child box">
          <div class="columns is-mobile border-bottom">
            <span i18n="@@agreement" class="column">
              <span class="title is-5 has-text-primary is-uppercase">Convenzione</span>
            </span>
            <a class="column is-narrow has-text-primary" (click)="editConvenzione = !editConvenzione">
              <span class="icon">
                <i class="fas" [ngClass]="{'fa-undo' : editConvenzione, 'fa-edit': !editContatti}"></i>
              </span>
            </a>
            <a class="column is-narrow has-text-primary" (click)="setTessera()" *ngIf="editConvenzione">
              <span class="icon">
                <i class="fas fa-save"></i>
              </span>
            </a>
          </div>
          <div class="fix-horizontal-form">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label i18n="@@association" class="label">Associazione</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select" *ngIf="editConvenzione; else staticAssociazione">
                      <select style="width:100%" name="associazioneField" [ngModel]="socio.idAssociazione"
                        (ngModelChange)="onChangeAssociazione($event)">
                        <option [ngValue]="undefined" i18n="@@selectInsurance">--Seleziona associazione--</option>
                        <option *ngFor="let associazione of associazioni" [ngValue]="associazione.id">
                          {{associazione.ragioneSociale}}
                        </option>
                      </select>
                    </div>
                    <ng-template #staticAssociazione>
                      <input class="input is-static" type="text" readonly [(ngModel)]="socio.nomeAssociazione"
                        name="nomeAssociazione">
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label" i18n="@@cardAssociation">Tess.Ass.</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input class="input" [disabled]="!socio.idAssociazione" [(ngModel)]="socio.tesseraAssociazione"
                      name="tesseraAssociazione" [class.is-static]="!editConvenzione" [readonly]="!editConvenzione"
                      type="text" maxlength="255">
                  </div>
                  <p class="help is-danger" *ngIf="editConvenzione && socio.idAssociazione && !socio.tesseraAssociazione"
                    i18n="@@dataRequired">
                    Dato richiesto
                  </p>
                </div>
              </div>
            </div>
            <div class="notification is-primary is-size-7" *ngIf="editConvenzione">
              L'utente si assume le responsabilità dei dati inseriti.<br />Dolomiti Emergency Onlus si riserva il diritto
              di verificare e nel caso correggere iscrizioni ad associazioni non corrispondenti alle informazioni in
              proprio possesso.
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
 

</div>